import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';

export const renderOnViewportChange: GraphRendererPlugin = (
  pluginInterface,
) => {
  pluginInterface.viewport.on('frame-end', () => {
    if (pluginInterface.viewport.dirty) {
      pluginInterface.requestRender();
      pluginInterface.viewport.dirty = false;
    }
  });
};
